export class Constants {
    public static Environment = "Production";
    public static ClientId = "5a04ebac-d357-4842-b514-8361903bf1d3";
    public static TenantUrl = "https://login.microsoftonline.com/bf0768d6-b60c-427e-9b94-c4b7ee7b43b8";
}